module.exports = __webpack_public_path__ + "img/down-gx3.f8ccf435.jpg";